import { Space } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { dayjs } from '../../../../common/lib/dayjs.js'

interface Props {
  date?: string
  space?: Space
}

export const SearchEntityRowTrailingContent = ({ space, date }: Props) => {
  return (
    <div className="grid gap-1">
      <div className="hidden sm:block place-self-end text-xs text-content-muted items-center col-span-full">
        <span>
          {space?.name}
          {space?.private && <SvgIcon className="ms-1" inline name="lock" />}
        </span>
      </div>
      <div className="sm:place-self-end items-center col-span-full">
        <span className="text-xs text-content-muted">
          {dayjs(date).fromNow()}
        </span>
      </div>
    </div>
  )
}
